import { createAsyncThunk } from "@reduxjs/toolkit";
import { UsersAPI } from "api/api/usersApi/usersApi";
import axios from "axios";
import { GetUsersWithoutPromocodesParams, GetUsersWithoutPromocodesResponse } from "api/api/usersApi/types";

export const getUsersWithoutPromocodes = createAsyncThunk<GetUsersWithoutPromocodesResponse, GetUsersWithoutPromocodesParams>(
  "users/getUsersWithoutPromocodes",
  async ({ voucherId, ...params }, { rejectWithValue }) => {
    try {
      const response = await UsersAPI.getUsersWithoutPromocodes({ voucherId, ...params });
      return response.data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while getting users without promocodes", error.response?.data);
        return rejectWithValue(error.response?.data || "Unknown error");
      }
      else {
        console.error("Error while getting users without promocodes", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);